import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelectRosterSelectGroup from '../../../components/CustomSelectRosterSelectGroup';
import CustomSelectRosterSelectUser from '../../../components/CustomSelectRosterSelectUser';

export const mapRosterUsersToFormData = (rosterUsers = []) => ({
   userId: [
      ...new Set(
         rosterUsers
            .map((item) => item.userId)
            .filter((id) => id !== null && id !== undefined && id !== '')
      ),
   ],
   groupId: [
      ...new Set(
         rosterUsers
            .map((item) => item.groupId)
            .filter((id) => id !== null && id !== undefined && id !== '')
      ),
   ],
});

export const sanitizeUsersFormData = (formData, allUser = [], GroupData = []) => ({
   userId: (formData.userId || []).filter(
      (id) => id && allUser.some((user) => user.userId == id)
   ),
   groupId: (formData.groupId || []).filter(
      (id) => id && GroupData.some((group) => group.id == id)
   ),
});

export const buildUsersRosterPayload = (rosterId, formData, allUser = [], GroupData = []) => {
   const sanitized = sanitizeUsersFormData(formData, allUser, GroupData);

   return {
      rosterId,
      userIds: sanitized.userId.join(','),
      groupIds: sanitized.groupId.join(','),
      langId: localStorage.getItem('i18nextLngId'),
   };
};

export const RosterUsersGroupsStep = ({
   formData,
   onInputChange,
   allUser,
   GroupData,
   onRemoveUser,
   onRemoveGroup,
}) => {
   const { t } = useTranslation();

   return (
      <div className="space-y-5 pt-2">
         <div>
            <label className="block text-sm font-medium mb-2">
               {t('rosterWizard.select-groups')}
            </label>
            <CustomSelectRosterSelectGroup
               multiple
               name="group"
               value={formData.groupId}
               onChange={onInputChange}
               options={GroupData}
               dataType="group"
               onRemoveItem={onRemoveGroup}
            />
         </div>

         <div>
            <label className="block text-sm font-medium mb-2">
               {t('rosterWizard.select-users')}
            </label>
            <CustomSelectRosterSelectUser
               multiple
               name="user"
               value={formData.userId}
               onChange={onInputChange}
               options={allUser}
               dataType="user"
               onRemoveItem={onRemoveUser}
            />
         </div>
      </div>
   );
};

export default RosterUsersGroupsStep;
